// Mock data for portfolio - to be replaced with backend data

export const designer = {
  name: "Arush Agarwal",
  role: "Senior Watch Designer",
  company: "Titan Company Limited",
  location: "Bengaluru, India",
  email: "arush08@gmail.com",
  phone: "+91 98765 43210",
  tagline: "Designing time, one detail at a time.",
  intro:
    "I've always been fascinated by how things work, not just mechanically, but also by the emotions they evoke, the ones that felt intuitive and well-crafted. For me, a watch is far more than a device that tells time. It is often an expression of personality, aspiration and one's achievement. The best watches create an emotional connection that extends beyond their function.",
  bio: [
    "As a watch design lead and product strategist, I strive to balance the functional demands of the category requiring emphasis on ergonomics, usability, and legibility, with the emotional qualities that make a product memorable through material selection, tactile interaction and visual storytelling that play an important role in shaping an experience.",
    "My role extends well beyond the drawing board. I work closely across marketing, engineering, and manufacturing teams, translating ideas into products while ensuring that the original design intent is carried through every stage of the process.",
    "I believe a truly successful product is one that stands the test of time, they are built to last physically, but more importantly, they leave a lasting emotional imprint on the people who use them."
  ],
  socials: [
    { label: "Instagram", href: "https://instagram.com" },
    { label: "Behance", href: "https://behance.net" },
    { label: "LinkedIn", href: "https://linkedin.com" },
    { label: "Read.cv", href: "https://read.cv" }
  ],
  portrait:
    "/img/3c805097_txjlazzn_4.jpg",
  stats: [
    { value: "07", label: "Years at Titan" },
    { value: "24", label: "Collections shipped" },
    { value: "3", label: "Design awards" },
    { value: "\u221e", label: "Sketches drawn" }
  ]
};

export const projects = [
  {
    id: "01",
    slug: "stellar-3-micromotor",
    title: "Micromotor",
    client: "Titan \u2014 Stellar Three",
    year: "2024",
    tags: ["Micro-Motor", "Astronomy", "Integrated"],
    cover: "/img/9e224283_u6rhicla_st3_2.1.jpg",
    gallery: [
      {
        url: "/img/a0927c39_29f4podh_st3_1.1.jpg",
        bg: "#000000",
        large: "/img/a0927c39_29f4podh_st3_1.1.jpg"
      },
      {
        url: "/img/9e224283_u6rhicla_st3_2.1.jpg",
        bg: "#000000",
        large: "/img/550e5323_7m77e64s_st3_2.jpg"
      },
      {
        url: "/img/ed056a29_s0yn8uvq_st3_3.1.jpg",
        bg: "#000000",
        large: "/img/040854b6_vbpedp4h_st3_3.jpg"
      },
      {
        url: "/img/7c3ce479_t1q45qap_st3_4.1.jpg",
        bg: "#000000",
        large: "/img/044ce888_sauwkvnk_st3_4.jpg"
      },
      "/img/a0a194f3_74eee2tz_5.jpg",
      "/img/c49b4884_370uebeu_6.jpg",
      {
        url: "/img/5ac92d3d_205zlmgm_st3_7.jpg",
        bg: "#000000"
      },
      "/img/f9e68c83_n9mkand2_8.jpg"
    ],
    tileSummary:
      "Part of the Stellar portfolio, the Micromotor watch explored a more modular interpretation of astronomical watchmaking by leveraging Titan\u2019s in-house micromotor platform.",
    summary:
      "The Micromotor watch was designed to expand the astronomical offering within the Stellar portfolio through a more modular and expressive approach to complications. As a lead designer, I chose to build the concept around Titan\u2019s in-house micromotor platform, exploring how independent motor architecture could unlock greater functional flexibility while enabling a distinctive interpretation of celestial time display.",
    role: "Lead Designer",
    duration: "13 months",
    narrative: [
      {
        heading: "Strategic Positioning",
        body: [
          "With each Stellar series, I explored introducing a complication rooted in astronomical watchmaking. For this concept, the objective was to showcase the versatility of the in-house micromotor platform and move beyond conventional mechanical layouts.",
          "The micromotor architecture allowed individual motors to be programmed for dedicated functions while offering freedom in their placement across the dial. I used this flexibility to create a more differentiated composition combining time, zodiac indication, and moon phase into a layout that felt both technical and emotionally connected to the theme of astronomy."
        ]
      },
      {
        heading: "Dial Details",
        body: [
          "The dial was designed to prioritize clarity while building a strong celestial identity. I chose an enamel-inspired sunray finish with a deep radial gradient to create visual depth and draw focus toward the central display that showcase a jumping hour.",
          "The composition follows a restrained dual-complication layout, allowing each indication to remain legible without overwhelming the dial. The matte black zodiac and moon phase discs were detailed with fine white graphics to create contrast and reinforce the classic cosmos aesthetic. Applied indices, polished bronze accents, and faceted detailing around the sub-displays were intentionally introduced to catch light and create moments of richness that complement the warmth of the case finish."
        ]
      },
      {
        heading: "Case Design",
        body: [
          "The case was designed to integrate three independent motors, a two-hand module for time display and two single-hand motors dedicated to the zodiac and moon phase indications. This architecture enabled multiple complications while maintaining a clean and balanced visual hierarchy.",
          "I designed the shaped case around a circular time display to create familiarity, while introducing an antique bronze finish to evoke the warmth and timeless character often associated with classical astronomical instruments. Four integrated pushers were added to individually calibrate each function, making interaction with the complications intuitive and precise. The caseback was further developed as a storytelling element, incorporating graphics that explain and celebrate the astronomical references used within the watch."
        ]
      }
    ]
  },
  {
    id: "02",
    slug: "stellar-1",
    title: "Stellar 1",
    client: "Titan \u2014 Stellar Series",
    year: "2024",
    tags: ["Automatic", "Semi-Precious", "Integrated"],
    cover: "/img/6d876ae2_ssg3zksu_cover_.jpg",
    gallery: [
      {
        url: "/img/005d4203_raeil8qn_st1_1.1.jpg",
        large: "/img/d931e8e0_aeaxjqub_st1_1.jpg"
      },
      {
        url: "/img/1b580cfa_976rd8vm_st1_2.1.jpg",
        bg: "#000000",
        large: "/img/68603450_rzgg8kt2_st1_2.jpg"
      },
      {
        url: "/img/5a6ce013_jv14dddl_st1_3.1.jpg",
        bg: "#000000",
        large: "/img/9e8bea4b_6ocp14i0_st1_3.jpg"
      },
      {
        url: "/img/b5dcfece_10qboha1_st1_4.1.jpg",
        bg: "#000000",
        large: "/img/b575e996_3ip4ek9z_st1_4.jpg"
      },
      "/img/ba07f4b6_sd605uex_detail.jpg",
      "/img/704452c6_4iojzf63_tile_6_.jpg",
      "/img/9b9ea3eb_z1eo8e6p_tile_7.jpg",
      "/img/54171d6f_1zapr7ip_crown_detail.jpg"
    ],
    tileSummary:
      "The Stellar 1 series, designed around layered architecture, unconventional time display, and celestial-inspired materiality to create a more expressive interpretation of mechanical watchmaking.",
    summary:
      "The Stellar 1 series, designed with a focus on architectural form, layered construction, and an unconventional interpretation of time display. Through the project, I explored how materiality, depth, and movement could come together to create a more celestial expression of mechanical watchmaking.",
    role: "Lead Designer",
    duration: "12 months",
    narrative: [
      {
        heading: "Strategic Positioning",
        body: [
          "The Stellar series emerged from an opportunity to create a more expressive interpretation of mechanical watchmaking. Inspired by celestial phenomena and the visual depth of space, I explored the use of semi-precious stones, layered construction, and Titan\u2019s in-house automatic calibres to craft watches that felt both technically sophisticated and emotionally engaging. The result was a design language that balanced mechanical complexity with contemporary elegance."
        ]
      },
      {
        heading: "Dial Details",
        body: [
          "The dial incorporates finely cut semi-precious stones such as malachite and aventurine, selected to evoke the visual character of the sky, and deep space. Their natural textures introduce depth and variation while maintaining a restrained visual balance.",
          "A strategic aperture within the dial reveals the in-house automatic movement, while the hour display is interpreted through a lume-filled planetary pointer designed to suggest the orbital movement of a planet around the sun."
        ]
      },
      {
        heading: "Case Design",
        body: [
          "The watch was designed as an integrated leather timepiece with a layered case architecture that allowed different surfaces to carry distinct finishes, creating a deliberate balance between satin brushing and polished detailing.",
          "The inner case, housing the in-house automatic calibre, was developed with a restrained satin finish, while the outer structural frame incorporates polished chamfers to create contrast and visual depth. Beyond its visual role, the outer frame also functions as a protective structure around the inner case, adding both durability and dimensionality to the construction."
        ]
      }
    ]
  },
  {
    id: "03",
    slug: "500m-divers",
    title: "500M Diver's",
    client: "Titan \u2014 Zero Hour",
    year: "2024",
    tags: ["Diver's", "Automatic", "Titanium Grade 5"],
    cover: "/img/3cff80d5_slrmfp7g_10071KM01_1.jpg",
    gallery: [
      "/img/3cff80d5_slrmfp7g_10071KM01_1.jpg",
      "/img/f4cb53a6_sxlic2ar_Steel_1_1.jpg",
      "/img/1cdf4b12_0qofn5e6_dive_3.jpeg",
      "/img/bb67a42f_net97osg_dive_2.jpeg",
      "/img/beacd814_fu1r4u67_dive_4.jpeg",
      {
        url: "/img/59863e65_wduscpfg_10071KM01_6.png",
        bg: "#000000"
      },
      "/img/33061373_y89itvcg_dive_1.jpeg",
      "/img/46dac4ba_e0ad39cz_Steel_Backcase_copy.jpg"
    ],
    tileSummary:
      "A 500M professional diver developed with a focus on functional clarity, ergonomic detailing, and a patented dual-lock bezel system that shaped the identity of the watch.",
    summary:
      "Titan Zero Hour Diver 500M was conceived as Titan\u2019s first professional 500M diver\u2019s watch. As design lead, I focused on developing a distinctive design language while rethinking the way a diver interacts with the watch, improving control, ergonomics, and functionality through innovations such as the patented Aqua Lock bezel system.",
    role: "Lead Designer",
    duration: "14 months",
    narrative: [
      {
        heading: "Strategic Positioning",
        body: [
          "The Diver's 500M was conceived in response to the growing interest in professional diver's watches within the enthusiast community. It was important for the watch to establish a distinct identity within an increasingly competitive category which led to the development of the patented \u201cAqua Lock\u201d bezel system, a mechanism designed to restrict bezel rotation in both directions instead of just one. I took inspiration from a simple gesture of unlocking a DSLR camera lens cap, an observation that eventually shaped the functional direction of the bezel-locking system."
        ]
      },
      {
        heading: "Dial Details",
        body: [
          "The dial was designed with a strong emphasis on legibility, restraint, and functional clarity. I chose a matte-finished surface to maintain a clean and noise-free character, while introducing a subtle gradient inspired by the visual depth of the sea.",
          "The hands and indices were developed around the Titan hourglass motif, with proportions carefully balanced to support quick readability under varying conditions. Both feature a 250-micron application of Super-LumiNova X1 grade lume for enhanced low-light visibility.",
          "To further improve dive readability, I differentiated the minute hand through a subtle colour variation, allowing it to stand out more distinctly during timing operations underwater."
        ]
      },
      {
        heading: "Case Design",
        body: [
          "While designing the titanium case around Titan's in-house automatic calibre 7AC0, I wanted the architecture to accommodate the technical requirements of a professional diver's watch, including an anti-magnetic shell, movement holder, helium release valve, and multiple O-ring systems required for 500M water resistance without compromising wearability or proportion.",
          "The bezel proportions were developed specifically to integrate the Aqua Lock system along with a sapphire-topped insert that improves the clarity and luminosity of the Super-LumiNova filled markings. I chose a medium-tooth knurling pattern for the lock mechanism to create a more secure and ergonomic grip, while visually carrying the detailing along the perimeter of the bezel.",
          "Several smaller decisions were also guided by underwater usability, including the addition of a lume-filled screw button integrated within the lock system. The bracelet was designed specifically for the project as well, carrying forward the angular visual language established through the hands and indices."
        ]
      }
    ]
  },
  {
    id: "04",
    slug: "squircle",
    title: "Squircle",
    client: "Titan \u2014 Edge",
    year: "2023",
    tags: ["Slim Quartz", "Ceramic", "Semi-Premium"],
    cover: "/img/8e201e40_uad7d1ou_cover_updated.jpg",
    coverPosition: "50% 55%",
    gallery: [
      {
        url: "/img/8eb3490e_1hxpoamy_sq_1.1.jpg",
        bg: "#F5F5F5",
        large: "/img/511a2185_xnz1sjb8_sq_1.jpg"
      },
      {
        url: "/img/6209ed4c_rpjp5g2f_sq_2.1.jpg",
        bg: "#F5F5F5",
        large: "/img/393df652_xlgix0o7_sq_2.jpg"
      },
      {
        url: "/img/920fb67c_iqook7ne_sq_3.1.jpg",
        bg: "#000000",
        large: "/img/2d4780c1_u5p6uy5f_sq_3.jpg"
      },
      {
        url: "/img/0d897a78_vsxzr0z9_sq_4.1.jpg",
        bg: "#000000",
        large: "/img/32f80542_rgi5g86j_sq_4.jpg"
      },
      "/img/58a9072d_jqlrconu_6.jpg",
      "/img/595bc42f_43cxqh0e_7.jpg",
      {
        url: "/img/be894717_d41hd4fi_sq_7.jpg",
        bg: "#F5F5F5"
      },
      "/img/68d59258_qqvb8rth_8.jpg"
    ],
    tileSummary:
      "A watch designed around a balanced \u201cSquircle\u201d geometry, exploring how proportion, slimness, and surface continuity could create a softer and more timeless interpretation of a shaped watch.",
    summary:
      "The Squircle was designed to challenge the conventional distinction between round and shaped watches through a softer, more balanced form. The project explored how proportion, slimness, and surface continuity could come together to create a timeless silhouette centered around the squircle geometry.",
    role: "Lead Designer",
    duration: "11 months",
    narrative: [
      {
        heading: "Strategic Positioning",
        body: [
          "I designed the Squircle as part of the Edge Ceramic collection to strengthen the brand's presence within the premium watch segment through a more distinctive and recognizable form language.",
          "Rather than relying on ornamentation, the focus was placed on geometry and restraint. By combining the softness of a circle with the structure of a square, I developed a \u201cSquircle\u201d form that felt both minimal and expressive. The matte black ceramic edition of the watch was later presented at the GPHG, marking Titan's first participation as an Indian brand."
        ]
      },
      {
        heading: "Dial Details",
        body: [
          "The dial was designed to remain visually restrained while carrying subtle expressive details in line with the minimal philosophy of the Edge series.",
          "The 12 and 6 o'clock markers were intentionally kept as the primary printed indices, while the 3 and 9 o'clock positions are suggested through a soft transition in surface finishing rather than explicit markers. This reduction of visual elements allowed the form, material, and proportions of the watch to remain the central focus."
        ]
      },
      {
        heading: "Case Design",
        body: [
          "The watch was designed around the material qualities of ceramic and sapphire, using both not only for their premium character but also for the unique sensory experience they could create.",
          "A specially developed convex ripple sapphire crystal was introduced to create changing visual reflections and a more tactile interaction with the surface of the watch. Considerable attention was given to maintaining fluid transitions across the case, allowing the curves to flow seamlessly into the lugs while preserving the slim profile of the Edge collection.",
          "The lugs themselves were designed to structurally hold the sapphire crystal in place, expressing a more functional approach to the construction. The ceramic bracelet was developed as a direct extension of the case, with each link following the same curvature and visual rhythm established through the lugs."
        ]
      }
    ]
  },
  {
    id: "05",
    slug: "stellar-2-luna",
    title: "Luna",
    client: "Titan \u2014 Stellar Two",
    year: "2024",
    tags: ["Automatic Moon Phase", "Semi-Precious", "Integrated"],
    cover: "/img/159059f0_tloaa6z5_1.jpg",
    gallery: [
      {
        url: "/img/089e931c_w6rkma57_lu_1.1.jpg",
        large: "/img/31b665c6_i1xf2c0o_lu_1.jpg"
      },
      {
        url: "/img/37478282_1ewj5j69_lu_2.1.jpg",
        bg: "#000000",
        large: "/img/e9f29911_hek7l1b1_lu_2.jpg"
      },
      {
        url: "/img/1f423d83_tyazmre5_lu_4.1.jpg",
        bg: "#F5F5F5",
        large: "/img/9fe685ba_7f7j4cv8_lu_4.jpg"
      },
      {
        url: "/img/88479450_cjvy40r1_lu_3.1.jpg",
        large: "/img/24d9b6e1_i624pcpd_lu_3.jpg"
      },
      {
        url: "/img/86e8966b_0ltc8lad_lu_5.jpg",
        bg: "#F5F5F5"
      },
      {
        url: "/img/9fcdbfb1_dst6ieba_lu_6.jpg",
        bg: "#F5F5F5"
      },
      {
        url: "/img/db58f579_iegvt5k7_lu_7.jpg",
        bg: "#F5F5F5"
      },
      {
        url: "/img/90036549_bqud7u6n_lu_8.jpg",
        bg: "#F5F5F5"
      }
    ],
    tileSummary:
      "A moon phase watch from the Stellar Two series, designed to combine celestial storytelling, layered depth, and material detailing through an in-house astronomical calibre.",
    summary:
      "Part of the Stellar Two series, Luna was designed around a more expressive interpretation of astronomical watchmaking through the introduction of an in-house moon phase calibre. The project explored how celestial storytelling, layered depth, and material detailing could come together to create a more immersive mechanical experience.",
    role: "Lead Designer",
    duration: "14 months",
    narrative: [
      {
        heading: "Strategic Positioning",
        body: [
          "Building on the foundation of Stellar One, the Stellar Two series was developed with more advanced complications and a stronger focus on mechanical expression. For Luna, I chose to center the design around the newly developed in-house moon phase module based on the 7AC0 platform, using the complication itself as the emotional focal point of the watch.",
          "To elevate the experience further, I incorporated materials such as aventurine and ceramic, balancing technical sophistication with a richer visual character while maintaining the contemporary identity of the Stellar collection."
        ]
      },
      {
        heading: "Dial Details",
        body: [
          "The dial was designed to create the feeling of observing a celestial body suspended within space. I used aventurine as the base layer to introduce a subtle star-like texture, while retaining familiar graphic cues from the Stellar One series to maintain visual continuity across the collection.",
          "The moon phase display itself was developed as a layered construction. The lowest layer incorporates a Super-LumiNova X1 filled moon surface detailed with crater-like textures, over which a rotating transparent disc gradually reveals the moon phases through a 29.5-day cycle. Surrounding this is a floating minute ring with luminous indices suspended between clean circular layers, helping maintain clarity while enhancing the illusion of depth."
        ]
      },
      {
        heading: "Case Design",
        body: [
          "To evolve the Stellar portfolio while retaining continuity within the series, I carried forward the core case architecture from Stellar One and refined it through material and ergonomic upgrades. The bezel was reworked in ceramic to introduce a sharper contrast and a more premium tactile quality, while the integrated bracelet was redesigned for improved comfort, fit, and surface detailing.",
          "The case proportions were intentionally kept clean and sculpted, allowing the polished ceramic bezel and domed crystal to visually frame the dial while enhancing the depth of the moon phase display."
        ]
      }
    ]
  },
  {
    id: "06",
    slug: "300m-divers",
    title: "300M Diver's",
    client: "Titan \u2014 Zero Hour",
    year: "2024",
    tags: ["Diver's", "Automatic", "Titanium Grade 5"],
    cover: "/img/5a82ce8f_i7gjh084_cover.webp",
    gallery: [
      {
        url: "/img/706d0c31_zhfxp87r_300_1.1.jpg",
        large: "/img/e121171b_mzaza6gp_300_1.jpg"
      },
      {
        url: "/img/00f702e6_oaywpgrd_300_2.1.jpg",
        large: "/img/23d4e923_xqzuwcd3_300_2.jpg"
      },
      {
        url: "/img/7d85b00e_iqt7al1g_300_3.1.jpg",
        bg: "#000000",
        large: "/img/8f17dd5b_9u4mznmm_300_3.jpg"
      },
      {
        url: "/img/9c55adf2_6wvrauu1_300_4.1.jpg",
        bg: "#000000",
        large: "/img/94efd3f5_6ng3at0o_300_4.jpg"
      },
      {
        url: "/img/c46ee004_ott8p650_300_5.jpg",
        bg: "#000000"
      },
      {
        url: "/img/68a72599_5lk3leur_300_6.jpg",
        bg: "#000000"
      },
      {
        url: "/img/1109c951_l3x4t05g_300_7.jpg",
        bg: "#000000"
      },
      {
        url: "/img/82858cce_a0a40rfn_300_8.jpg",
        bg: "#000000"
      }
    ],
    tileSummary:
      "A 300M professional diver from the Titan Zero Hour collection, designed as a more accessible interpretation of the series while retaining its core functionality, robustness, and visual identity.",
    summary:
      "A 300M professional diver developed as part of the Titan Zero Hour collection, launched alongside the 100M, 200M, and 500M variants. The project focused on creating a more accessible interpretation of the collection while retaining the core identity, functionality, and robustness of the series.",
    role: "Lead Designer",
    duration: "10 months",
    narrative: [
      {
        heading: "Strategic Positioning",
        body: [
          "While the 500M variant was built around the patented Aqua Lock system, the 300M was designed with a more restrained and versatile approach suited to a wider audience within the segment.",
          "During the development process, I chose to retain the core case architecture of the 500M to ensure continuity within the collection while enabling a leaner and more efficient product development cycle. The intent was to balance strong specifications, wearability, and usability within a cleaner and more approachable diver format."
        ]
      },
      {
        heading: "Dial Details",
        body: [
          "The dial takes cues from several signature elements from the Zero Hour collection, including the angular indices, Super-LumiNova X1 grade lume application, and the gradient transition toward the lower half of the dial.",
          "To reinforce the underwater character of the watch, I introduced a textured wave pattern inspired by the movement of deep-sea currents, adding depth without disrupting legibility. The minute ring was kept restrained, with subtle colour differentiation and clearly defined markings to maintain functional clarity during dive timing operations."
        ]
      },
      {
        heading: "Case Design",
        body: [
          "The watch carries forward the same titanium case architecture developed for the 500M, allowing seamless integration of Titan's in-house automatic calibre 7AC0 along with water resistance capabilities rated up to 300M.",
          "To establish a clearer distinction within the collection, I redesigned the bezel without the Aqua Lock system, introducing a ceramic bezel insert with flush-applied Super-LumiNova markings for improved contrast and nighttime visibility. The ceramic construction also helped elevate the overall material perception of the watch while maintaining a cleaner visual language.",
          "The bezel knurling was intentionally broadened compared to the 500M, giving the watch a more refined and balanced character while improving tactile interaction."
        ]
      }
    ]
  }
];

export const services = [
  {
    no: "01",
    title: "Concept & Sketching",
    body: "From mood and reference to ten weeks of pencil — the first 80% of a watch is decided here."
  },
  {
    no: "02",
    title: "Industrial Design",
    body: "Case, crown, pushers, lugs, casebacks — engineered for wear, manufacture and the long run."
  },
  {
    no: "03",
    title: "Dial & Type",
    body: "Indices, fonts, finishes and applied elements. Where horology becomes graphic design."
  },
  {
    no: "04",
    title: "Material & Finish",
    body: "Steel, titanium, ceramic, gold, lume, lacquer — choosing materials that age the way they should."
  },
  {
    no: "05",
    title: "Prototype Review",
    body: "From CAD to T1, T2, T3 samples. Calibrating tolerance, weight and the feel of the crown."
  },
  {
    no: "06",
    title: "Brand & Storytelling",
    body: "Naming, packaging and the small printed card — the watch on paper before it reaches the wrist."
  }
];

export const experience = [
  {
    period: "2021 \u2014 Present",
    role: "Senior Watch Designer",
    org: "Titan Company Limited",
    place: "Bengaluru",
    body:
      "Leading mechanical and dress collections across Edge, Nebula and Atelier. Mentoring two junior designers and owning concept-to-production for two flagship launches a year."
  },
  {
    period: "2018 \u2014 2021",
    role: "Watch Designer",
    org: "Titan Company Limited",
    place: "Bengaluru",
    body:
      "Worked across Sonata, Fastrack and Titan Edge. Shipped twelve collections including Field No. 04 and the first Horizon GMT."
  },
  {
    period: "2017 \u2014 2018",
    role: "Apprentice Designer",
    org: "Independent atelier",
    place: "La Chaux-de-Fonds, CH",
    body:
      "Six months in Switzerland working on case finishing and dial layout under a master watchmaker."
  },
  {
    period: "2013 \u2014 2017",
    role: "B.Des. Industrial Design",
    org: "IDC, IIT Bombay",
    place: "Mumbai",
    body:
      "Industrial design with a thesis on horology, ergonomics and the wristwatch as a daily object."
  }
];

export const recognitions = [
  { year: "2024", title: "India Design Mark", project: "Meridian Chronograph" },
  { year: "2023", title: "Red Dot \u2014 Honorable Mention", project: "Obsidian Dress" },
  { year: "2022", title: "CII Design Excellence", project: "Horizon GMT" },
  { year: "2021", title: "Featured \u2014 Hodinkee India", project: "North Star" }
];

export const testimonials = [
  {
    quote:
      "Arush thinks about a watch the way a writer thinks about a sentence \u2014 every comma matters. Working with him made our flagship feel inevitable.",
    name: "Revathi Kant",
    role: "Chief Design Officer, Titan"
  },
  {
    quote:
      "Few designers in India can move from a pencil sketch to a 0.02mm tolerance and back without losing the soul of the object. He's one of them.",
    name: "Manish Sharma",
    role: "Movement Specialist"
  },
  {
    quote:
      "He has a quiet, almost editorial way of designing \u2014 the watches don\u2019t shout, but they don\u2019t leave the wrist either.",
    name: "Aanchal Mehra",
    role: "Editor, Hodinkee India"
  }
];
